import { render } from "./glob-table-old.vue?vue&type=template&id=41d32cc8&scoped=true"
import script from "./glob-table-old.vue?vue&type=script&lang=js"
export * from "./glob-table-old.vue?vue&type=script&lang=js"

import "./glob-table-old.vue?vue&type=style&index=0&id=41d32cc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d32cc8"]])

export default __exports__